const fillCondition = () => {
  return {
    isOnlineAgent: value => value?.includes && value.includes('conv'),
    isCallAgent: value => value?.includes && value.includes('call'),
    isOnlineAndCallAgent: value => value?.includes && value.includes('conv') && value.includes('call'),
    isOnlineAndTicketAgent: value => value?.includes && value.includes('conv') && value.includes('ticket'),
    isCallAndTicketAgent: value => value?.includes && value.includes('call') && value.includes('ticket'),
    isNewTicketAgent: value => value?.includes && value.includes('ticket'),
    isAllAgent: value => value?.includes && value.includes('call') && value.includes('ticket') && value.includes('conv')
  };
};

export default fillCondition;
